export enum GameStatusType {
  Active = 'active',
  LeaguesRecalculation = 'leagues-recalculation',
  GameFinishedBeforeResults = 'game-finished-before-results',
  GameFinishedAfterResults = 'game-finished-after-results',
  Mocks = 'mocks',
}
